import styled from 'styled-components'

export const SSLicenseIdColContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
